// extracted by mini-css-extract-plugin
export var active = "_2l-b";
export var activeIndicator = "_2l-6";
export var animate = "_2l-a";
export var disabled = "_2l-c";
export var flat = "_2l-1";
export var fullWidth = "_2l-3";
export var lg = "_2l-9";
export var md = "_2l-8";
export var redoButtonTabGroup = "_2l-0";
export var sm = "_2l-7";
export var tabButton = "_2l-4";
export var tabButtonsContainer = "_2l-2";
export var xs = "_2l-5";